import React from "react";
import OnlyInvoieToPrint from "./bill-summary-statement";

import ReactToPrint from "react-to-print";
import { Printer } from "react-feather";

class PrintableInvoice extends React.PureComponent {
  render() {
    return <OnlyInvoieToPrint />;
  }
}

class Print extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="zp-inv-toolbar">
        <ReactToPrint
          trigger={() => {
            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
            // to the root node of the returned component as it will be overwritten.
            return (
              <button type="button" className="zp-inv-print-btn">
                <Printer size={16} aria-hidden="true" />
                Print PDF
              </button>
            );
          }}
          content={() => this.componentRef2}
        />
        </div>
        <PrintableInvoice ref={(el) => (this.componentRef2 = el)} />
      </div>
    );
  }
}

export default Print;
